export const comments_3253780 = {"data":{"data":[],"links":{}}}